var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('app-header'),_vm._v(" "),_c('main',{class:_vm.$style.content},[_c('div',{class:[_vm.$style.inner, {
        [_vm.$style.innerPadding]: !_vm.settings.noPadding,
      }]},[_vm._t("default")],2)]),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('client-only',[_c('cookie-notice'),_vm._v(" "),(_vm.$auth.loggedIn)?_c('lazy-agreements-dialog'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }